import { render, staticRenderFns } from "./ActionsC1.vue?vue&type=template&id=070cc0b2&scoped=true&"
import script from "./ActionsC1.vue?vue&type=script&lang=js&"
export * from "./ActionsC1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070cc0b2",
  null
  
)

export default component.exports